import React, {Component} from 'react';
import getFieldFactory from "../../Endpoint/FieldFactory";
import FieldGroups from "../FieldGroups";
import {connect} from "react-redux";
import {addSubField} from "../../../../../store/actions/subFields";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";
import CustomTableNotice from '../../CustomTableNotice';

class Output extends Component {

	state = {
		selectedFilterToAdd: ''
	};

	handleSelectedFilterToAdd = (e) => {
		this.setState({selectedFilterToAdd: e.target.value});
	};

	getField(name) {
		let field = getFieldFactory().getNewDefaultFieldGroupForOutput(name, name);

		field.fields = [...field.fields, ...getFieldFactory().getExtraFields()];
		return [field];
	}

	render() {

		const {addSubField, group, customTables} = this.props;

		return (
			<React.Fragment>
				<FieldGroupContext.Consumer>

					{({ endpointId, endpoint, currentItem, action }) => (
						<React.Fragment>

							{ endpoint[action][currentItem].tableSelection[0].fields[0].value ?
								<React.Fragment>

						<h3>Fields to display in the output: ({endpoint.displayCustomTable[currentItem].output.length})</h3>

						Select a field to output: <select value={this.state.selectedFilterToAdd} onChange={this.handleSelectedFilterToAdd}>
							<option value="">Select a field</option>
							{customTables && customTables[endpoint[action][0]['tableSelection'][0].fields[0]['value']] && customTables[endpoint[action][0]['tableSelection'][0].fields[0]['value']].map((el, index) => <option key={index} value={el}>{el}</option>)}
						</select>

						<button
							onClick={() => addSubField(endpointId, this.getField(customTables[endpoint[action][0]['tableSelection'][0].fields[0]['value']].filter(el => el === this.state.selectedFilterToAdd)), currentItem, group, action)}
							disabled={!this.state.selectedFilterToAdd ? 'disabled' : ''}
							className="button-secondary"
						>
							Add field
						</button>

						<FieldGroups group={group} />

						</React.Fragment> : <CustomTableNotice/> }

					</React.Fragment>)}
				</FieldGroupContext.Consumer>
			</React.Fragment>
		);
	}
}

const mapStateToProps = ( state ) => ( state );

const mapDispatchToProps = dispatch => ({
	addSubField: ( endpointId, field, currentItem, group, parentGroup ) => dispatch( addSubField( endpointId, field, currentItem, group, parentGroup ) ),
});

export default connect( mapStateToProps, mapDispatchToProps )(Output);
